// extracted by mini-css-extract-plugin
export var img = "EmployeePhoto-module--img--cGRFk";
export var placeholder = "EmployeePhoto-module--placeholder--k3jtH";
export var root = "EmployeePhoto-module--root--r7HYY";